<template>
    <main-content>
        <div class="clearfix">
            <router-link class="kt-nav__link m-2 btn btn-outline-primary float-right" to="/pos/add-new-request">
                {{ $t('label.sending_request') }}
            </router-link>
        </div>
        <admin-get  v-if="$can('manage', 'pos')"></admin-get>
        <visitorGet  v-else-if="$can('read', 'pos')"></visitorGet>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import adminGet from './components/admin/Get'
import visitorGet from './components/visitor/Get'

export default {
    components: {
        'main-content': mainContent,
        adminGet,visitorGet
    },
}
</script>

<style>

</style>